import React, {useContext, useEffect, useState} from "react";
import {toast} from "react-toastify";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faMedkit, 
    faMapMarkerAlt, 
    faPhone, 
    faBuilding, 
    faBed, 
    faRuler,
    faHospital,
    faCrosshairs,
    faRoute
} from "@fortawesome/free-solid-svg-icons";
import SectionDescription from "../../composants/sectionDescription/description";
import { LoadingContext } from "../../composants/loadingContext";
import Loader from "../../composants/loader/Loader";

export default function Services() {
    const {loading, setLoading} = useContext(LoadingContext);
    const [usraj, setUsraj] = useState([]);
    const [userLocalusation, setUserLocalusation] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);

    const calculateDistance = (userLat, userLon, usrajLat, usrajLon)=>{
        const R = 6371; // Rayon de la Terre en kilomètres
        const latDistance = toRadians(usrajLat - userLat);
        const lonDistance = toRadians(usrajLon - userLon);

        const a = Math.sin(latDistance / 2) * Math.sin(latDistance / 2) +
            Math.cos(toRadians(userLat)) * Math.cos(toRadians(usrajLat)) *
            Math.sin(lonDistance / 2) * Math.sin(lonDistance / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    const toRadians = (degrees)=>{
        return degrees * (Math.PI / 180);
    }

    const fetchServices = ()=>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                setUserLocalusation({
                    latitude: latitude,
                    longitude:longitude
                });
                setLoading(true);
                axiosInstance().get('public/api/centrepartenaire/proches/'+latitude+'/'+longitude)
                    .then(function (response) {
                        let data = response.data;
                        if((data == null)||(data.length===0)){
                            setUsraj([]);
                        }else{
                            setUsraj(data)
                        }
                        setLoading(false);
                    })
                    .catch(function (error) {
                        setUsraj([]);
                        setLoading(false);
                        console.error('Error fetching services:', error);
                    });
            }, function(error) {
                toast.error("Erreur lors de la récupération de la position.");
            });
        } else {
            toast.error("La géolocalisation n'est pas supportée par ce navigateur.");
        }
    }

    useEffect(
        ()=>{
            document.title='Services de Santé - USRAJ';
            fetchServices();
        },
        []
    );

    return (
        <>
            {loading && <Loader />}
            
            {/* Hero Section */}
            <div className="relative bg-gradient-to-br from-green-600 via-teal-500 to-blue-600 text-white py-20 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>
                
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 shadow-2xl">
                            <FontAwesomeIcon icon={faHospital} className="text-4xl" />
                        </div>
                        <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">
                            Services de Santé à Proximité
                        </h1>
                        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
                            Unités de Santé de Reproduction Ados Jeunes (USRAJ) près de vous
                        </p>
                        {usraj.length > 0 && (
                            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full">
                                <FontAwesomeIcon icon={faCrosshairs} className="text-green-300" />
                                <span className="text-lg font-semibold">{usraj.length}</span>
                                <span className="text-white/80">centre{usraj.length > 1 ? 's' : ''} trouvé{usraj.length > 1 ? 's' : ''}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {usraj.length === 0 && !loading ? (
                <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center py-20">
                    <div className="text-center max-w-md mx-auto px-4">
                        <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-green-100 to-teal-100 rounded-full mb-6">
                            <FontAwesomeIcon icon={faHospital} className="text-5xl text-green-500" />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-3">
                            Aucun service à proximité
                        </h3>
                        <p className="text-gray-600">
                            Nous n'avons trouvé aucun centre de santé près de votre position actuelle.
                        </p>
                    </div>
                </div>
            ) : (
                <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="space-y-8">
                            {usraj.map((value, index) => {
                                const distance = userLocalusation ? calculateDistance(
                                    userLocalusation.latitude,
                                    userLocalusation.longitude,
                                    value.latittude,
                                    value.longitude
                                ) : 0;
                                
                                return (
                                    <div 
                                        key={value.id}
                                        className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-1"
                                        onMouseEnter={() => setHoveredCard(value.id)}
                                        onMouseLeave={() => setHoveredCard(null)}
                                        style={{
                                            animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                                        }}
                                    >
                                        <div className="flex flex-col lg:flex-row">
                                            {/* Image Section */}
                                            <div className="lg:w-80 h-64 lg:h-auto relative overflow-hidden bg-gradient-to-br from-green-100 to-teal-100">
                                                <img 
                                                    src={value.photo?.includes('null') ? '/images/image.png' : value.photo}
                                                    alt={value.nom}
                                                    className="w-full h-full object-cover transition-transform duration-700"
                                                    style={{
                                                        transform: hoveredCard === value.id ? 'scale(1.1)' : 'scale(1)'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = '/images/image.png';
                                                    }}
                                                />
                                                {/* Distance Badge */}
                                                <div className="absolute top-4 right-4 bg-gradient-to-r from-green-500 to-teal-500 text-white px-4 py-2 rounded-full shadow-lg">
                                                    <div className="flex items-center gap-2">
                                                        <FontAwesomeIcon icon={faRoute} />
                                                        <span className="font-bold">{Math.round(distance * 100) / 100} km</span>
                                                    </div>
                                                </div>
                                                
                                                {/* Category Badge */}
                                                <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                                                    <span className="text-sm font-semibold text-gray-700">{value.category}</span>
                                                </div>
                                            </div>

                                            {/* Content Section */}
                                            <div className="flex-1 p-6 lg:p-8">
                                                {/* Header */}
                                                <div className="mb-6">
                                                    <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-2">
                                                        {value.nom}
                                                    </h2>
                                                    <div className="h-1 w-20 bg-gradient-to-r from-green-500 to-teal-500 rounded-full"></div>
                                                </div>

                                                {/* Info Grid */}
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                                    {/* Contact Info */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faPhone} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Téléphone</p>
                                                            <p className="text-sm font-semibold text-gray-800">{value.telephone || 'Non disponible'}</p>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Adresse</p>
                                                            <p className="text-sm font-semibold text-gray-800" title={value.address}>
                                                                {value.address || 'Non disponible'}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Superficie */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faRuler} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Superficie</p>
                                                            <p className="text-sm font-semibold text-gray-800">{value.superficie} km²</p>
                                                        </div>
                                                    </div>

                                                    {/* Buildings */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faBuilding} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Bâtiments</p>
                                                            <p className="text-sm font-semibold text-gray-800">{value.nombreBat}</p>
                                                        </div>
                                                    </div>

                                                    {/* Beds */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faBed} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Lits disponibles</p>
                                                            <p className="text-sm font-semibold text-gray-800">{value.nombreLit}</p>
                                                        </div>
                                                    </div>

                                                    {/* Morgue */}
                                                    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gray-500 to-gray-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faHospital} className="text-white" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Morgue</p>
                                                            <p className="text-sm font-semibold text-gray-800">{value.morgue ? 'Oui' : 'Non'}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* GPS Coordinates */}
                                                <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-teal-50 rounded-xl border border-blue-100">
                                                    <p className="text-sm text-gray-600 mb-1 font-medium">Coordonnées GPS</p>
                                                    <p className="text-gray-800 font-mono text-sm">{value.latittude}, {value.longitude}</p>
                                                </div>

                                                {/* Services Offered */}
                                                {value.serviceOfferts && value.serviceOfferts.length > 0 && (
                                                    <div className="border-t border-gray-100 pt-6">
                                                        <div className="flex items-center gap-3 mb-4">
                                                            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center">
                                                                <FontAwesomeIcon icon={faMedkit} className="text-white" />
                                                            </div>
                                                            <h3 className="text-lg font-bold text-gray-800">
                                                                Services Offerts ({value.serviceOfferts.length})
                                                            </h3>
                                                        </div>
                                                        <div className="flex flex-wrap gap-2">
                                                            {value.serviceOfferts.map((service) => (
                                                                <span
                                                                    key={service.id}
                                                                    className="px-4 py-2 bg-gradient-to-r from-green-100 to-teal-100 text-green-700 rounded-full text-sm font-medium border border-green-200 hover:shadow-md transition-shadow duration-300"
                                                                >
                                                                    {service.libelle}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
            
            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </>
    );
}